"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Header/CampaignSettings.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Tooltip = require('web/components/Tooltip');
var _Header = require('web/components/RightSide/Header');












const archivedDesc = (action, isArchived) =>
  isArchived ? `Can't ${action} an archived campaign` : ''

/* The "···" menu: each edit opens the campaign wizard at its step. Send, Edit
 * message and Add more have their own buttons on the page, so they're not
 * here (Rev 28 R1, Rev 30 Z1). */
const CampaignSettings = ({
  isCampaignArchived,
  isCampaignActive,
  onEditDetails,
  onExportCampaign,
  onArchive,
  onUnarchive,
  archiveBlockedReason = null,
}) => (
  _react2.default.createElement(_Header.HeaderMoreToggle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
    , _react2.default.createElement(_Tooltip.TooltipMenuItem, {
      iconSrc: "/assets/icons/header/edit-dark.svg",
      disabled: isCampaignArchived,
      label: "Edit campaign details"  ,
      desc: archivedDesc('edit', isCampaignArchived),
      onClick: onEditDetails, __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
    )
    ,  onExportCampaign && (
      _react2.default.createElement(_Tooltip.TooltipMenuItem, {
        iconSrc: "/assets/icons/icon-download-dark-grey.svg",
        label: "Export this campaign"  ,
        onClick: onExportCampaign, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      )
    )
    ,  isCampaignArchived
      ? (
          _react2.default.createElement(_Tooltip.TooltipMenuItem, {
            iconSrc: "/assets/icons/icon-completed-dark-grey.svg",
            label: "Unarchive campaign" ,
            onClick: onUnarchive, __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
          )
        )
      : (
          _react2.default.createElement(_Tooltip.TooltipMenuItem, {
            iconSrc: "/assets/icons/icon-completed-dark-grey.svg",
            label: "Archive campaign" ,
            isDestructive: true,
            disabled: isCampaignActive || !!archiveBlockedReason,
            desc: isCampaignActive ? 'Pause the campaign to archive it' : _nullishCoalesce(archiveBlockedReason, () => ( '')),
            onClick: onArchive, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
          )
        )
    
  )
)

exports. default = CampaignSettings
